import { useState,useEffect, useContext } from "react";
import { AxiosInstance, DialogType, FormActions } from "../../../utils/constants";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { Button, Collapse, GridLegacy as Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import {Edit, KeyboardArrowDown,KeyboardArrowUp} from "@mui/icons-material";
import { FormVehiculos } from "../../form/form-vehiculos";
import { FormConductores } from "../../form/form-conductores";

const InitialFilterSearch = {
    rows_per_page:20,
    page_number:0,
    filter_search:"",
    cod_empresa:null
    
  };
  

export const Conductoresview = ({
    parentData={}
})=>{
   
    const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
    const {dispatch,store} = useContext( AppContext );
    const [totalRows,setTotalRows] = useState(0);
    const [dataSetProdctos,setDataSetProductos] = useState([]);
    const [vehiculoData,setVehiculoData] = useState({}); 
    const [modalConfig,setModalConfig] = useState({
        isOpened:false,
        mode:FormActions.AGREGAR
    });
    useEffect(()=>{
        setFilterSearchPagination({
            ...filterSearchPagination,
            cod_empresa:parentData.cod
        });
    },[]);

    useEffect(()=>{
        console.log({filterSearchPagination});
        if ( filterSearchPagination.cod_empresa ){
            loadDataSet();
        }
    },[filterSearchPagination]);


  

    const loadDataSet = async(loading=true)=>{

        if (loading){
            dispatch({
              type:ActionTypes.setLoadingPage,
              data:true
            });
          }

       try{
        const {data} = await AxiosInstance.post("logistico/listar-conductores",{...filterSearchPagination});
        setDataSetProductos(data?.value?.data);
        setTotalRows(data?.value.total);
       }catch(e){

       }
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
        });
    }




    const handleChangePage = (event, newPage) => {
      
        setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
      };
  
      const handleChangeRowsPerPage = (event) => {
        setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
       
      };


    const columnsTable = [
        {
        
         key:"cod",
         keyValue:"cod",
         label:"ID",
         headerRender:(props)=>props.label,
         bodyRender:(props)=>props.value,
         typeRow:"string",
         sort:false,
         sortFunction:()=>{},
         sortStatus:"", 
  
        },
       
        {
        
          key:"nombres",
          keyValue:"nombres",
          label:"Nombres",
          headerRender:(props)=>props.label,
          bodyRender:(props)=>props.value,
          typeRow:"string",
          sort:false,
          sortFunction:()=>{},
          sortStatus:"", 
   
         },
         {
        
          key:"apellidos",
          keyValue:"apellidos",
          label:"Apellidos",
          headerRender:(props)=>props.label,
          bodyRender:(props)=>props.value,
          typeRow:"string",
          sort:false,
          sortFunction:()=>{},
          sortStatus:"", 
   
         },
         {
        
          key:"numero_documento",
          keyValue:"numero_documento",
          label:"Identificacion",
          headerRender:(props)=>props.label,
          bodyRender:(props)=>props.value,
          typeRow:"number",
          sort:false,
          sortFunction:()=>{},
          sortStatus:"", 
   
         },
         {
        
          key:"email",
          keyValue:"email",
          label:"Correo",
          headerRender:(props)=>props.label,
          bodyRender:(props)=>props.value,
          typeRow:"number",
          sort:false,
          sortFunction:()=>{},
          sortStatus:"", 
   
         },
         {
        
            key:"celular",
            keyValue:"celular",
            label:"Celular",
            headerRender:(props)=>props.label,
            bodyRender:(props)=>props.value,
            typeRow:"string",
            sort:false,
            sortFunction:()=>{},
            sortStatus:"", 
     
           },
           {
        
            key:"ind_estado",
            keyValue:"ind_estado",
            label:"Estado",
            headerRender:(props)=>props.label,
            bodyRender:(props)=>props.value,
            typeRow:"string",
            sort:false,
            sortFunction:()=>{},
            sortStatus:"", 
     
           },
         
            {
            key:"editar",
            keyValue:"cod",
            label:"Editar",
            headerRender:(props)=>props.label,
            bodyRender:({value})=><Button  onClick={e=>onEditVehice(value)}  variant="contained" size="small" startIcon={<Edit/>} >Editar</Button>,
            typeRow:"number",
            sort:false,
            sortFunction:()=>{},
            sortStatus:"", 
   
            },  
      ];


      const onEditVehice = (cod_item)=>{
        const payload = dataSetProdctos.find( item=>item.cod == cod_item);
        payload.vehiculo = {
          label:payload.nombre_vehiculo,
          value:payload.vehiculo_cod
        }
       
        setVehiculoData(payload);
        setModalConfig({
            isOpened:true,
            mode:FormActions.MODIFICAR
        });
      }
      const createVehicle = ()=>{
        setVehiculoData({});
            setModalConfig({
                isOpened:true,
                mode:FormActions.AGREGAR
            });
      }
      const onCloseVehicle = ()=>{
        setVehiculoData({});
        setModalConfig({
            isOpened:false,
            mode:FormActions.AGREGAR
        });
      }

      const onSendVehicle = (payload)=>{
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
          });
            AxiosInstance.post("logistico/crear-actualizar-conductor",{
                ...payload,
                cod_empresa_transporte:parentData?.cod
            }).then(({data})=>{
                onCloseVehicle();
                loadDataSet(false);
                
                dispatch({
                    type: ActionTypes.setModalInfo,
                    data: {
                      title: "Accion exitosa",
                      message: "Su accion se ha realizado con exito",
                      type: DialogType.exitoso,
                      isVisible: true
                    }
                  });

            }).catch(error=>{

                dispatch({
                    type: ActionTypes.setModalInfo,
                    data: {
                      title: "Error",
                      message: "Error al tratar de realizar la accion",
                      type: DialogType.peligro,
                      isVisible: true
                    }
                  });
              
            }).finally(()=>{
                dispatch({
                    type:ActionTypes.setLoadingPage,
                    data:false
                  });
            });
      }


    return (
        <>
        <FormConductores 
        onCloseVehicle={onCloseVehicle}
        vehiculo={vehiculoData}
        onSendData={onSendVehicle}
        parent_cod={parentData.cod}
       
        {
            ...modalConfig
        }

        />
        <Button onClick={createVehicle} variant="contained" color="primary" size="small" >Nuevo conductor</Button>
         <TableContainer>
               <Table>
            <TableHead>
              <TableRow>
              
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( (prod,prodIndex)=>
                 [ <TableRow key={prod.cod}  >
                    
                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                ]
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        
        </>
        
    )

}
